import { type ComponentType } from 'react';

import { EmailPreferencesTableApp } from './EmailPreferencesTableApp';
import { FlashApp } from './FlashApp';
import { FourOhOneKContributionsEditViewApp } from './FourOhOneKContributionsEditViewApp';
import { GenerateReportsApp } from './GenerateReportsApp';
import { ReportsApp } from './ReportsApp';
import SignablePackageApp from './SignablePackageApp';

import { components as BetterMfaComponents } from '../../better-mfa/index';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const apps: Record<string, ComponentType<any>> = {
  Reports: ReportsApp,
  EmailPreferencesTable: EmailPreferencesTableApp,
  GenerateReports: GenerateReportsApp,
  SmsSetupFlow: BetterMfaComponents.SmsSetupFlow,
  TotpSetupFlow: BetterMfaComponents.TotpSetupFlow,
  SudoChallengeFlow: BetterMfaComponents.SudoChallengeFlow,
  LoginChallengeFlow: BetterMfaComponents.LoginChallengeFlow,
  SignablePackage: SignablePackageApp,
  FourOhOneKContributionsEditView: FourOhOneKContributionsEditViewApp,
  Flash: FlashApp,
};

export function getReactApp(name: string) {
  const app = apps[name];

  if (!app) {
    throw new Error(`Could not resolve app with name: ${name}`);
  }

  return app;
}
